import React, { Component } from 'react'
import {Route,Router,Switch} from 'react-router-dom'
import { LoginPage } from './components/account/LoginPage'
import { RegisterPage } from './components/account/RegisterPage'
import { RestorePasswordPage } from './components/account/RestorePasswordPage'
import { PasswordRecoveryPage } from './components/account/PasswordRecoveryPage'
import { SessionEndedPage } from './components/account/SessionEndedPage'
import { dispatcherActionTypes, globalEventDispatcher } from './components/helpers/GlobalEventDispatcher'
import { History } from './components/helpers/History'
import { Home } from './components/Home'
import { Layout } from './components/Layout'
import { ResponseStatusePage } from './components/pages/ResponseStatusePage'
import { PrivateRoute } from './components/PrivateRoute'
import { constants, formModes } from './constants'
import { documentsRoutes } from './AppRoutes'
import { logout } from './components/helpers/HelperFunctions'
import { MainPage } from './components/MainPage'
import { DocumentsRegisterRoutes } from './components/DocumentsRegisterRoutes'
import { authHeader } from './components/helpers/AuthHeader'
import * as ModalDialogsTemplates from './components/ModalDialogsTemplates'
import './css/app.css'
export default class App extends Component {
    constructor(props) {
        super(props)
        let counterOfrequest = 0
        window.fetch = new Proxy(window.fetch, {
            apply(fetch, that, args) {
                if (args[0] !== "Document/SetCashe") {
                    counterOfrequest++
                    ModalDialogsTemplates.showLoader();
                }
                // Forward function call to the original fetch
                if (authHeader()) {
                    if (JSON.parse(localStorage?.getItem('user')) && (!args[0].startsWith('data:')))
                        args[0] += (args[0].includes("?") ? "&" : "?") + `companyId=${JSON.parse(localStorage?.getItem('user'))?.companies[0]?.id}`
                    if (args.length === 1) args.push({ headers: {} })
                    args[1].headers = args[1].headers ? args[1].headers : {}
                    args[1].headers = Object.assign(args[1].headers, authHeader())
                }
                const result = fetch.apply(that, args)
                const authorizationHeader = args[1]?.headers?.Authorization
                // Do whatever you want with the resulting Promise
                result.then(async (response) => {
                    if (args[0] !== "Document/SetCashe") {
                        counterOfrequest--;
                    }
                    if (counterOfrequest === 0)
                        ModalDialogsTemplates.hideLoader()
                    if (response.status === 500) {
                        window.onbeforeunload = null;
                        window.location.replace("/login")
                    }
                    if (response.status === 401 || (authorizationHeader && localStorage.getItem('user') === null)) {
                        if (!response.url.endsWith('/Account/LogOut'))
                            logout();
                    }
                })
                return result
            }
        })
    }
    componentDidMount() {
        this.historyChangeUnlisten = History.listen((location, action) => {
            let beforeReloadLocations = ['/request', '/simplerequest', '/contract', '/outgoingdocument', '/ISCCEUCertificate'];
            let needBeforeUploadMessage = location.pathname.startsWith('/document/edit/') ||
                beforeReloadLocations.some(url => url === location.pathname);
            if (needBeforeUploadMessage) {
                window.onbeforeunload = function () {
                    return true;
                }
            }
            else {
                window.onbeforeunload = null;
            }
        });
    }
    componentWillUnmount() {
        if (this.historyChangeUnlisten)
            this.historyChangeUnlisten();
    }
    render() {
        document.addEventListener('DOMContentLoaded', function () {
            var target = document.getElementById('root')
            target.onclick = () => { globalEventDispatcher.dispatch(dispatcherActionTypes.onUserAction) }
            const callback = function (mutationsList) {
                let mutationWasDone = false
                for (let mutation of mutationsList) {
                    if (mutation.type === 'childList') {
                        mutationWasDone = true
                    } else if (mutation.type === 'attributes') {
                        mutationWasDone = true
                    }
                }
                if (mutationWasDone) {
                    globalEventDispatcher.dispatch(dispatcherActionTypes.onUserAction)
                }
            }
            const observer = new MutationObserver(callback);
            observer.observe(target, {
                attributes: true,
                childList: true,
                subtree: true
            })
        })
        return (
            <Layout>
                <div id='modalDialog' className='modal-dialog-contaner'></div>
                <div id='modalSubDialog' className='modal-dialog-contaner'></div>
                <div id='modalSubDialogError' className='modal-dialog-contaner'></div>
                <div id="loadingDialog" className='modal-dialog-contaner'></div>
                <div id={constants.placeholderDialogId} className='modal-dialog-contaner'></div>
                <Router history={History}>
                    <Switch>
                        <PrivateRoute exact path='/' component={MainPage} />
                        <PrivateRoute exact path='/documents/:type/:status?' component={DocumentsRegisterRoutes} />
                        <PrivateRoute exact path='/prices' component={Home} />
                        <PrivateRoute path='/statutoryDocs/:tab?' component={Home} />
                        <PrivateRoute path='/templates/:tab?' component={Home} />
                        <PrivateRoute exact path='/settings/:tab?' component={Home} />
                        <PrivateRoute exact path='/search' component={Home} />
                        <PrivateRoute path='/admin/:tab?' component={Home} />
                        <PrivateRoute exact path='/no-acces' component={Home} />
                        {documentsRoutes.map((item) => (
                            item.modes.map(
                                (mode) => <PrivateRoute exact path={`/${mode === formModes.create ? item.baseUrl : "document"}/${mode === formModes.create ? "" : mode}${(mode === formModes.create ? "" : "/:id")}`} key={`doc-page-route-${item.baseUrl}-${mode}`} component={Home} />
                            )
                        ))}
                        <Route exact path="/login" component={LoginPage} />
                        <Route exact path="/register" component={RegisterPage} />
                        <Route exact path="/password-recovery" component={PasswordRecoveryPage} />
                        <Route path="/restorepassword" component={RestorePasswordPage} />
                        <Route exact path="/session-ended" component={SessionEndedPage} />
                        <Route exact path="/404"><ResponseStatusePage code={"404"} /></Route>
                        <Route exact path="/500"><ResponseStatusePage code={"500"} /></Route>
                        <Route><ResponseStatusePage code={"404"} /></Route>
                    </Switch>
                </Router>
            </Layout>
        )
    }
}